import { Component, ElementRef, EventEmitter, Injectable, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Filter, Filters } from '../models/filters/filters';
import { Department } from '../models/department/department';
import { Label } from '../models/label/label';
import * as moment from 'moment';
import { AccountService } from 'src/app/services/account/account.service';
import { Router } from '@angular/router';
import { DepartmentService } from '../services/department/department.service';
import { LabelService } from '../services/label/label.service';
import { CategoriesService } from '../services/categories/categories.service';
import { Category, CategoryTree, Service } from '../models/categoryTree/category-tree';
import { CalendarService } from '../services/calendar/calendar.service';
import { AdminServiceService } from '../services/admin/admin-service.service';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
@Injectable({ providedIn: 'root' })
export class FiltersComponent implements OnInit {

  @Input() schedulerObjInput;
  @Input() calendarInput;

  @Output('searchRequest') searchRequestOutput: EventEmitter<any> = new EventEmitter();

  @ViewChild('loadFilterDiv') loadFilterDiv;
  @ViewChild('partnerDiv') partnerDiv;
  @ViewChild('typeDiv') typeDiv;
  @ViewChild('datefromDiv') datefromDiv;
  @ViewChild('datetoDiv') datetoDiv;
  @ViewChild('statusDiv') statusDiv;
  @ViewChild('guestDiv') guestDiv;
  @ViewChild('categoryDiv') categoryDiv;
  @ViewChild('serviceDiv') serviceDiv;

  account: any = this.accountService.vendor;
  isUser: boolean = localStorage.getItem('HechRomeoRole') === 'User' ? true : false;

  filterDate = { from: '', to: '' };
  filters: Filters = new Filters();
  newFilters: Filters = new Filters();
  newFilterDate = { from: '', to: '' };
  newCategoriesSelect;
  categoriesSelect = {
    selectedCategory0: null,
    selectedCategory1: null,
    selectedCategory2: null,
    selectedCategory3: null,
    categoryObj0: { categories: [] },
    categoryObj1: { categories: [] },
    categoryObj2: { categories: [] },
    categoryObj3: { categories: [] },
    currentServiceList: [],
    selectedServiceInList: null,
  };
  partnersList = []
  allFilters: Filter[] = [];
  allLabels: Label[] = [];
  allDepartments: Department[];
  categoryTree: CategoryTree;
  allCategories: Category[] = [];
  allServices: Service[] = [];
  cartServices: Service[] = [];
  cartServicesNotActivated: Service[] = [];
  isDetailsService: boolean = false;
  lastEvSelected: any = undefined;
  schedulerObj: any;
  calendar: any;
  selectedDate: Date = new Date();
  viewDeleteReservation: boolean = false;
  serviceSelected: string;
  loadFilterId: string = null;

  constructor(private accountService: AccountService,
    private router: Router,
    private departmentService: DepartmentService,
    private labelService: LabelService,
    private categoriesService: CategoriesService,
    private calendarService: CalendarService,
    private adminService: AdminServiceService
  ) { }

  ngOnInit(): void {
    this.filters.account = localStorage.getItem('HechRomeoVendor') ? localStorage.getItem('HechRomeoVendor') : this.account;
    this.newFilters.account = localStorage.getItem('HechRomeoVendor') ? localStorage.getItem('HechRomeoVendor') : this.account;
    this.newCategoriesSelect = { ...this.categoriesSelect };
    this.newFilterDate = { ...this.filterDate };
    this.schedulerObj = this.schedulerObjInput;
    this.calendar = this.calendarInput;

    if (this.calendarService.getFilters){
      this.filters = this.calendarService.getFilters;
      this.loadFilterId = this.filters.loadFilterId;
    }
    this.getAllFilters();
    this.getAllLabels();
    this.getAllDepartments();
    this.getAllCategories();
  }

  ngAfterViewInit() {
    if (this.router.url === '/calendar' || this.router.url === '/calendarReport' 
        || (this.router.url.indexOf('?') > 0 && (this.router.url.split('?')[0] === '/calendar' || this.router.url.split('?')[0] === '/calendarReport'))) {
      if (this.router.url === '/calendarReport' || (this.router.url.indexOf('?') > 0 && this.router.url.split('?')[0] === '/calendarReport')) {
        this.loadFilterDiv.nativeElement.hidden = true;
        this.loadFilterDiv.nativeElement.className = '';
        this.partnerDiv.nativeElement.hidden = false;
        this.partnerDiv.nativeElement.className = 'd-flex';
        this.typeDiv.nativeElement.hidden = false;
        this.datefromDiv.nativeElement.className = "form-group col-3";
        this.datetoDiv.nativeElement.className = "form-group col-3";
        this.statusDiv.nativeElement.className = "form-group col-3";
        this.getAllPartnersFromFee();
      }
      else {
        this.loadFilterDiv.nativeElement.hidden = false;
        this.loadFilterDiv.nativeElement.className = 'd-flex';
        this.partnerDiv.nativeElement.hidden = true;
        this.partnerDiv.nativeElement.className = '';
        this.typeDiv.nativeElement.hidden = true;
        this.datefromDiv.nativeElement.className = "form-group col-4";
        this.datetoDiv.nativeElement.className = "form-group col-4";
        this.statusDiv.nativeElement.className = "form-group col-4";
      }
      this.statusDiv.nativeElement.hidden = false;
      this.guestDiv.nativeElement.hidden = false;
      this.guestDiv.nativeElement.className = 'd-flex';
      this.categoryDiv.nativeElement.hidden = false;
      this.categoryDiv.nativeElement.className = 'd-flex';
      this.serviceDiv.nativeElement.hidden = false;
      this.serviceDiv.nativeElement.className = 'd-flex';

      if (this.loadFilterId == null || this.loadFilterId == "")
        this.searchRequest();

      setInterval(() => {
          this.searchRequest();
      }, 300000);
    }
    else {
      this.loadFilterDiv.nativeElement.hidden = true;
      this.loadFilterDiv.nativeElement.className = '';
      this.typeDiv.nativeElement.hidden = true;
      this.statusDiv.nativeElement.hidden = true;
      this.guestDiv.nativeElement.hidden = true;
      this.guestDiv.nativeElement.className = '';
      this.categoryDiv.nativeElement.hidden = true;
      this.categoryDiv.nativeElement.className = '';
      this.serviceDiv.nativeElement.hidden = true;
      this.serviceDiv.nativeElement.className = '';
    }
  }

  getAllFilters(): void {
    this.calendarService.getFiltersFromAccount(this.accountService.vendor).subscribe((data) => {
      this.allFilters = data;
    });
  }

  getAllLabels(): void {
    if (this.isUser || localStorage.getItem('HechRomeoVendor')) {
      this.labelService.getLinkedVendorLabels(this.accountService.vendor).subscribe((data) => {
        this.allLabels = data.labels;
      });
    } else {
      this.labelService.getLabels().subscribe((data) => {
        this.allLabels = data.labels;
      });
    }
  }

  getAllDepartments(): void {
    if (this.isUser || localStorage.getItem('HechRomeoVendor')) {
      this.departmentService.getLinkedVendorDepartments(this.accountService.vendor).subscribe(data => {
        this.allDepartments = data.departments;
      });
    } else {
      this.departmentService.getDepartments().subscribe((data) => {
        this.allDepartments = data.departments;
      });
    }
  }

  getAllCategories(): void {
      this.categoriesService.getVendorTree(this.accountService.vendor).subscribe((data) => {
        this.categoryTree = data;
        this.allCategories = data.categories;
        this.categoriesSelect.categoryObj0 = { ...data };
        this.newCategoriesSelect = { ...this.categoriesSelect };
        this.exporeCategories(this.allCategories, '');

        if (this.loadFilterId != null && this.loadFilterId != "") {
          this.selectFilter();
          this.searchRequest();
        }
        else {
          for (let x = 0; x <= 4; x++) {
            if (x == 0 && this.filters.categoryroot) {
              this.newCategoriesSelect['selectedCategory' + x] = this.filters.categoryroot;
              this.selectCategory(x);
            } else if (x < 4 && this.filters['categoryl' + x]) {
              this.newCategoriesSelect['selectedCategory' + x] = this.filters['categoryl' + x];
              this.selectCategory(x);
            } else if (x == 4 && this.filters.service) {
              this.newCategoriesSelect.selectedServiceInList = this.filters.service;
            }
          }
        }
      });
  }

  // Gets the list of all partners
  getAllPartnersFromFee() {
    this.calendarService.getPartnerList(this.accountService.vendor).subscribe((data) => {
      this.partnersList = data;
    });
  }

  exporeCategories(array, tree): void {
    for (const element of array) {
      if (tree.length > 0) {
        tree = tree.concat(' > ');
      }

      tree = tree.concat(element.title.it);

      this.exporeCategories(element.categories, tree);

      for (const item of element.services) {
        item.tree = tree;
        if (item.deleted == false && item.cartenabled == false && item.visible == true) {
          this.allServices.push(item);
        }

        if (item.deleted == false && item.cartenabled == true) {
          this.cartServices.push(item);
          this.cartServicesNotActivated.push(item);
        }
      }

      const i = tree.lastIndexOf('>');

      tree = tree.substring(0, i - 1);
    }
  }

  clearNewFilter(): void {
    this.newFilters = { ...this.filters };
    this.newCategoriesSelect = { ...this.categoriesSelect };
    this.newFilterDate = { ...this.filterDate };
  }

  selectCategory(currentObj): void {
    this.clearOtherObjects(currentObj);

    if (currentObj != 3) {
      if (this.newCategoriesSelect['selectedCategory' + currentObj]) {
        this.newCategoriesSelect['categoryObj' + (currentObj + 1)] =
          this.newCategoriesSelect['categoryObj' + currentObj].categories.find(
            (obj) =>
              obj.id == this.newCategoriesSelect['selectedCategory' + currentObj]
          );
        if (this.newCategoriesSelect['selectedCategory' + currentObj].services)
          this.newCategoriesSelect.currentServiceList =
            this.newCategoriesSelect['categoryObj' + (currentObj + 1)].services;
      }
    } else {
      if (this.newCategoriesSelect['selectedCategory' + currentObj]) {
        this.newCategoriesSelect.currentServiceList = this.newCategoriesSelect[
          'categoryObj' + currentObj
        ].categories.find(
          (obj) =>
            obj.id == this.newCategoriesSelect['selectedCategory' + currentObj]
        ).services;
      }
    }
  }

  clearOtherObjects(currentObj): void {
    for (let x = currentObj + 1; x < 4; x++) {
      this.newCategoriesSelect['categoryObj' + x] = { categories: [] };
      this.newCategoriesSelect['selectedCategory' + x] = null;
    }

    this.newCategoriesSelect.currentServiceList = [];
    this.newCategoriesSelect.selectedServiceInList = null;
  }

  clearFilter(loadFilter): void {
    if (loadFilter)
      this.loadFilterId = null;
    this.filters = new Filters();
    this.filters.account = this.isUser ? localStorage.getItem('HechRomeoVendor') : this.account;
    this.newCategoriesSelect = {
      selectedCategory0: null,
      selectedCategory1: null,
      selectedCategory2: null,
      selectedCategory3: null,
      categoryObj0: { categories: [] },
      categoryObj1: { categories: [] },
      categoryObj2: { categories: [] },
      categoryObj3: { categories: [] },
      currentServiceList: [],
      selectedServiceInList: null,
    };
    this.filters.newFilterDate = { from: '', to: '' };
    this.newCategoriesSelect.categoryObj0 = this.categoriesSelect.categoryObj0;
    this.newCategoriesSelect.selectedServiceInList = this.categoriesSelect.selectedServiceInList;
    this.filters.loadFilterId = this.loadFilterId;

    this.calendarService.saveFilters(this.filters);
  }

  async searchRequest(): Promise<void> {
    // if (this.calendarService.getFilters){
    //   this.filters = this.calendarService.getFilters;
    // }

    if (this.schedulerObj) {
      let notbefore = '';
      let notafter = '';
      const selectedDate = moment(this.selectedDate);

      this.filters.period.from = notbefore;
      this.filters.period.to = notafter;

      let currentView = this.schedulerObj.views[this.schedulerObj.getCurrentViewIndex()] ?
                        this.schedulerObj.views[this.schedulerObj.getCurrentViewIndex()].option :
                        this.schedulerObj.currentView;
      switch (currentView) {
        case 'Day':
        case 'TimelineDay':
          notbefore = selectedDate
            .toISOString(true)
            .substring(0, 10)
            .split('-')
            .reverse()
            .join('/');
          notafter = selectedDate.clone()
            .toISOString(true)
            .substring(0, 10)
            .split('-')
            .reverse()
            .join('/');
          break;
        case 'Week':
        case 'TimelineWeek':
          notbefore = selectedDate
            .startOf('day')
            .startOf('week')
            .toISOString(true)
            .substring(0, 10)
            .split('-')
            .reverse()
            .join('/');
          console.log('notbefore', notbefore);
          notafter = selectedDate
            .startOf('day')
            .endOf('week')
            .toISOString(true)
            .substring(0, 10)
            .split('-')
            .reverse()
            .join('/');
          console.log('notbefore', notafter);
          break;
        case 'Month':
        case 'TimelineMonth':
          notbefore = selectedDate
            .startOf('day')
            .startOf('month')
            .toISOString(true)
            .substring(0, 10)
            .split('-')
            .reverse()
            .join('/');
          notafter = selectedDate
            .startOf('day')
            .endOf('month')
            .toISOString(true)
            .substring(0, 10)
            .split('-')
            .reverse()
            .join('/');
          break;
      }

      // this.filters.period.from = notbefore;
      // this.filters.period.to = notafter;
      // this.newFilters.period.from = notbefore;
      // this.newFilters.period.to = notafter;

      this.filters.period.from = this.filters.newFilterDate.from ? this.formatDate(this.filters.newFilterDate.from) : notbefore;
      this.filters.period.to = this.filters.newFilterDate.to ? this.formatDate(this.filters.newFilterDate.to) : notafter;
      this.filters.hidden = this.viewDeleteReservation;
      this.filters.hidden = this.viewDeleteReservation;

      for (let x = 0; x < 4; x++) {
        if (this.newCategoriesSelect['selectedCategory' + x]) {
          if (x == 0) {
            this.filters.categoryroot = this.newCategoriesSelect.categoryObj0.categories
              .find((obj) => obj.id == this.newCategoriesSelect.selectedCategory0).id;
          } else {
            this.filters['categoryl' + x] = this.newCategoriesSelect['categoryObj' + x].categories
              .find((obj) => obj.id == this.newCategoriesSelect['selectedCategory' + x]).id;
          }
        } 
        else {
          if (x == 0) {
            this.filters.categoryroot = null;
          } else {
            this.filters['categoryl' + x] = null;
          }
        }
      }

      if (this.newCategoriesSelect.selectedServiceInList)
        this.filters.service = this.newCategoriesSelect.selectedServiceInList;
      else
        this.filters.service = null;

      if (this.router.url.indexOf('/calendar') >= 0 && this.router.url.indexOf('/calendarReport') < 0) {
        this.calendarService.searchRequest(this.filters)
          .subscribe((data) => {
            this.calendarService.saveFilters(this.filters);
            this.searchRequestOutput.emit({data: data});
        });
      } else {
        let data: any[] = [];
        if (
          this.filters.type == -1 ||
          this.filters.type == undefined ||
          this.filters.type == 1
        ) {
          data['myReport'] = await this.calendarService.myReportSearch(this.filters).toPromise();
          data['myReportAdvanced'] = await this.calendarService.myReportAdvancedSearch(this.filters).toPromise();
        }

        if (
          this.filters.type == -1 ||
          this.filters.type == undefined ||
          this.filters.type == 0
        ) {
          data['report'] = await this.calendarService.reportSearch(this.filters).toPromise();
          data['reportAdvanced'] = await this.calendarService.reportAdvancedSearch(this.filters).toPromise();
        }

        this.calendarService.saveFilters(this.filters);
        this.searchRequestOutput.emit({data: data});
      }
    }
    else {
      this.isDetailsService = false;
      this.lastEvSelected = undefined;
      this.calendar.removeAllEvents();
      this.categoriesSelect = { ...this.newCategoriesSelect };
      this.filterDate = { ...this.filters.newFilterDate };
      if (this.filterDate.from && this.filterDate.from.length > 0) {
        let notbefore = moment(new Date(this.filterDate.from)).format(
          'DD/MM/YYYY'
        );
        this.filters.period.from = notbefore;
      }
      if (this.filterDate.to && this.filterDate.to.length > 0) {
      
        let notafter = moment(new Date(this.filterDate.to)).format('DD/MM/YYYY');
      
        this.filters.period.to = notafter;
      }
      console.log('date', this.filters.period.from, this.filters.period.to);
  
      // this.filters.period.from = "";
      // this.filters.period.to = "";
      console.log('Filters', this.filters);
      this.calendarService
        .getAdvancedServicePeriod(
          this.filters.account,
          this.serviceSelected,
          this.filters.period.from,
          this.filters.period.to
        )
        .subscribe((data) => {
          this.calendarService.saveFilters(this.filters);
          this.searchRequestOutput.emit({data: data})
        });
    }
  }

  formatDate(inputDate: string) {
    const date = new Date(inputDate);
    if (!isNaN(date.getTime())) {
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      const month = date.getMonth() < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      const year = date.getFullYear();

      return day + '/' + month + '/' + year;
    }
  }

  selectFilter() {
    this.clearFilter(false);

    let filter = this.allFilters.find((obj) => obj.id == this.loadFilterId);
    if (filter != null) {
      this.filters.account = filter.account;
      this.filters.categoryl1 = filter.data.categoryl1;
      this.filters.categoryl2 = filter.data.categoryl2;
      this.filters.categoryl3 = filter.data.categoryl3;
      this.filters.categoryroot = filter.data.categoryroot;
      this.filters.customeremail = filter.data.customeremail;
      this.filters.customerlastname = filter.data.customerlastname;
      this.filters.customername = filter.data.customername;
      this.filters.department = filter.data.department;
      this.filters.label = filter.data.label;
      this.filters.orderstatus = filter.data.orderstatus;
      this.filters.service = filter.data.service;
      this.filters.newFilterDate = { from: filter.data.period.from, to: filter.data.period.to };
      this.filters.period = { from: filter.data.period.from, to: filter.data.period.to };
      for (let x = 0; x <= 4; x++) {
        if (x == 0 && this.filters.categoryroot) {
          this.newCategoriesSelect['selectedCategory' + x] = this.filters.categoryroot;
          this.selectCategory(x);
        } else if (x < 4 && this.filters['categoryl' + x]) {
          this.newCategoriesSelect['selectedCategory' + x] = this.filters['categoryl' + x];
          this.selectCategory(x);
        } else if (x == 4 && this.filters.service) {
          this.newCategoriesSelect.selectedServiceInList = this.filters.service;
        }
      }
    }
  }

}
